import { useNavigate } from "react-router-dom";
import Layout from "../assets/component/Layout";
import { Col, Container, Row } from "react-bootstrap";

export default function Home() {
  const Navigate = useNavigate();

  return (
    <Layout>
      <section className="Inner-page-layout">
        <div className="">
          <h1>University Forms</h1>
          <div className="university-forms-cards">
            <Container>
              <Row>
                <Col lg={4}>
                  <div className="form-card-item">
                    <h2>Admission Application Form</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur. Mauris euismod non
                      dolor sit purus. Tempor in viverra sed nunc.
                    </p>
                    <button onClick={() => Navigate("/admission-application")}>
                      Select
                    </button>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-card-item">
                    <h2>Fee Payment Form</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur. Mauris euismod non
                      dolor sit purus. Tempor in viverra sed nunc.
                    </p>
                    <button onClick={() => Navigate("/fee-payment-form")}>
                      Select</button>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-card-item">
                    <h2>Leave Application Form</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur. Mauris euismod non
                      dolor sit purus. Tempor in viverra sed nunc.
                    </p>
                    <button onClick={() => Navigate("/leave-application-form")}>
                      Select</button>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-card-item">
                    <h2>Event Registration Form</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur. Mauris euismod non
                      dolor sit purus. Tempor in viverra sed nunc.
                    </p>
                    <button onClick={() => Navigate("/event-registration-form")}>
                      Select</button>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-card-item">
                    <h2>Library Membership Form</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur. Mauris euismod non
                      dolor sit purus. Tempor in viverra sed nunc.
                    </p>

                    <button onClick={() => Navigate("/library-membership-form")}>
                      Select</button>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-card-item">
                    <h2>Hostel Accommodation Form</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur. Mauris euismod non
                      dolor sit purus. Tempor in viverra sed nunc.
                    </p>
                    <button onClick={() => Navigate("/hostel-accommodation-form")}>
                      Select</button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </Layout>
  );
}
